<template>
    <div class="min-h-full overflow-y-auto bg-taupe-50">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'WelcomeTemplate',
}
</script>
